export enum Anchors {
  AboutMe = 'about-me',
  AddGames = 'add-games',
  GamingProfiles = 'gaming-profiles',
  Finalize = 'finalize',
}
